import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'src/app/globals';
import { Response } from 'src/app/models/response';
import { ParametroApiService } from 'src/app/services/parametro.service';

@Component({
  selector: 'app-mensaje-registro',
  templateUrl: './mensaje-registro.component.html',
  styleUrls: ['./mensaje-registro.component.scss']
})
export class MensajeRegistroComponent implements OnInit {
  flagMessage: number;
  flagBotonAceptar: boolean;
  titulo: string;
  subTitulo: string;

  constructor(private router: Router,
    private globals: Globals,
    private serviceParametro: ParametroApiService) { }

  ngOnInit() {
    this.flagMessage = this.globals.tipo_form_solicitante;
    this.flagBotonAceptar = this.globals.app_title === "WT003" ? true : false;
    this.caseMessage(this.flagMessage);
  }

  aceptar() {
    this.router.navigate(['']);
  }

  async caseMessage(flagMessage) {
    let flagTitulo = 0;
    let flagSubTitulo = 0;
    const codigo = 7;
    switch (flagMessage) {
      case 0:
        flagTitulo = 1;
        flagSubTitulo = 65;
        break;
      case 1:
        flagTitulo = 1;
        flagSubTitulo = 2;
        break;
      case 2:
        flagTitulo = 3;
        flagSubTitulo = 4;
        break;
      case 3:
        flagTitulo = 5;
        flagSubTitulo = 6;
        break;
      case 4:
        flagTitulo = 7;
        flagSubTitulo = 8;
        break;
      case 5:
        flagTitulo = 9;
        flagSubTitulo = 10;
        break;
      case 6:
        flagTitulo = 11;
        flagSubTitulo = 12;
        break;
      case 7:
        this.titulo = '¡Registro exitoso!';
        //this.subTitulo = 'Su información ha sido enviada, un gestor comercial validará; su Información y comunicará con Usted.';
        this.subTitulo = 'Su información ha sido enviada, un gestor comercial validará la información y se comunicará con usted a la brevedad.';
        break;
      case 8:
        this.titulo = '¡Bienvenido!';
        this.subTitulo = 'Puedes realizar tu Afiliación al Recibo Digital.';
        break;
      default:
        this.router.navigate(['']);
        break;
    }
    if (flagTitulo !== 0) {
      this.titulo = await this.obtenerMensaje(String(codigo), String(flagTitulo));
    }
    if (flagSubTitulo !== 0) {
      this.subTitulo = await this.obtenerMensaje(String(codigo), String(flagSubTitulo));
    }
  }

  async obtenerMensaje(codigo: string, subcodigo: string) {
    let descripcion = '';
    await this.serviceParametro.consultarParametro(codigo, subcodigo).toPromise().then(
      (response: Response) => {
        if (response.estado === 'OK') {
          if (response.resultado) {
            if(response.resultado.length>0){
              descripcion = response.resultado[0].vl_val_parametro
            }
          }
        }
      },
      (error) => {
        console.log("Error: " + error);
      }
    );
    return descripcion;
  }

}
